var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopScreenshare = function SvgStopScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.28 2.78a.75.75 0 0 0-1.06-1.06L19.91 3.028A3.027 3.027 0 0 0 19.5 3h-15a3 3 0 0 0-3 3v11.25a3 3 0 0 0 1.558 2.631L1.72 21.22a.75.75 0 1 0 1.06 1.06l19.5-19.5ZM4.216 18.723l1.326-1.325a.886.886 0 0 1-1.02-.95c.325-4.209 4.107-7.526 8.805-7.848V6.874c0-.79.946-1.197 1.52-.653l.96.911L18.439 4.5H4.5A1.5 1.5 0 0 0 3 6v11.25a1.5 1.5 0 0 0 1.216 1.473Zm8.56-8.56c-2.743.379-4.95 1.934-6.038 3.969a10.583 10.583 0 0 1 4.315-2.246l1.723-1.723Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21 6.16 1.283-1.282c.14.346.217.725.217 1.122v11.25a3 3 0 0 1-3 3h-.75a.75.75 0 0 1 0 1.5H5.41l3-3H19.5a1.5 1.5 0 0 0 1.5-1.5V6.16Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.327 13.834V15.2c0 .799.962 1.202 1.531.642l4.308-4.24a.9.9 0 0 0-.012-1.295l-1.18-1.12-1.062 1.062.759.72-2.844 2.799v-1.434l-1.5 1.5Z",
    fill: "#fff"
  })));
};
export default SvgStopScreenshare;